import { graphql } from 'gql';

export const appModulesReportGql = graphql(`
    query appModulesReport(
        $skip: Int
        $take: Int
        $modules: [ModuleEnum!]
        $includeHealth: Boolean
        $includeResources: Boolean
        $where: ServiceDataResultOfAppModuleReportFilterInput
        $order: [ServiceDataResultOfAppModuleReportSortInput!]
    ) {
        appModulesReport(
            skip: $skip
            take: $take
            modules: $modules
            includeHealth: $includeHealth
            includeResources: $includeResources
            where: $where
            order: $order
        ) {
            items {
                actionRequired
                buttonText
                code
                data {
                    branch
                    buildDate
                    commit
                    description
                    healthCheckData {
                        duration
                        healthChecks {
                            description
                            duration
                            error
                            name
                            status
                            validation {
                                message
                                metadata
                                property
                            }
                        }
                        status
                    }
                    id
                    name
                    release
                    tag
                }
                hasValidation
                hideValidation
                message
                result
                validation {
                    property
                    message
                }
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);
